import { Box, styled } from '@mui/material';
import { BackButton } from 'components/BackButton/BackButton';
import React from 'react';
import { ProgressBar } from '../../ProgressBar/ProgressBar';

interface HeaderBarProps {
  stepValue: number;
  backButtonDisabled?: boolean;
  onClickBackButton?: () => void;
  hasProgressBar?: boolean;
}
const StyledContainer = styled(Box)(({ theme }) => ({
  maxWidth: '1300px',
  width: '100%', // Ensure the container spans the full width
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1, 2),
  boxSizing: 'border-box',
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    minHeight: '56px', // Minimum touch target height for mobile devices
  },
}));
const StyledBackButton = styled(BackButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

export const HeaderBar = ({
  stepValue,
  onClickBackButton,
  hasProgressBar,
  backButtonDisabled,
}: HeaderBarProps) => (
  <StyledContainer className="sign-up-header-bar" id="sign-up-header-bar">
    <StyledBackButton
      color="primary"
      disabled={backButtonDisabled}
      onClick={onClickBackButton}
      className="sign-up-header-bar__back-button"
      id="sign-up-header-bar__back-button"
      aria-label="Go back"
    />
    <ProgressBar
      sx={{ visibility: hasProgressBar ? 'visible' : 'hidden' }}
      stepsProgress={stepValue}
      className="sign-up-header-bar__progress-bar"
      id="sign-up-header-bar__progress-bar"
      aria-hidden
    />
  </StyledContainer>
);
